export default "__VITE_ASSET__DIENrOf6__"